import { useSelector } from 'react-redux';
import { selectQuery } from '@client/catalog/redux/search/redux';

export function useSearchQuery(): string {
  return useSelector(selectQuery);
}
